import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { BasketRentPaymentSelectionAC } from './AC/BasketRentPaymentSelection.AC';
import { BasketRentPaymentSelectionOV } from './OV/BasketRentPaymentSelection.OV';
import { BasketRentPaymentSelectionAP } from './AP/BasketRentPaymentSelection.AP';
import { BasketRentPaymentSelectionDS } from './DS/BasketRentPaymentSelection.DS';
import { BasketRentPaymentSelectionOV as BasketCashPaymentSelectionOV_GB } from './OV/GB/BasketRentPaymentSelection.OV';
import { BasketSelectSectionStyled } from './BasketRentPaymentSelectionStyled';
import { SC } from '../../../styles/theme';

export type BasketRentPaymentSelectionProps = SC & {
    onClick: (value: string) => void;
    isSelected: boolean;
};

const BasketRentPaymentSelection = (props: BasketRentPaymentSelectionProps) => {
    if (BRAND === 'AC') return <BasketRentPaymentSelectionAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? (
            <BasketCashPaymentSelectionOV_GB {...props} />
        ) : (
            <BasketRentPaymentSelectionOV {...props} />
        );
    if (BRAND === 'AP') return <BasketRentPaymentSelectionAP {...props} />;
    if (BRAND === 'DS') return <BasketRentPaymentSelectionDS {...props} />;
    return <BasketSelectSectionStyled {...props} />;
};

export default BasketRentPaymentSelection;
